module.exports = __webpack_public_path__ + "fonts/AkkuratLL-Black.a691661e.otf";